(() => {
  'use strict';
  const mount = document.getElementById('alarmiko-native-offer');
  const source = document.getElementById('alarmiko-packages');
  const form = document.getElementById('alarmiko-product-form');
  if (!mount || !source || !form) return;
  const originals = [...source.querySelectorAll('[data-alarmiko-pack]')];
  if (originals.length !== 4) return;
  const marketCurrency = mount.dataset.currency;
  const language = mount.dataset.language;
  const formatter = new Intl.NumberFormat(language, {
    style: 'currency', currency: marketCurrency,
    minimumFractionDigits: marketCurrency === 'CZK' ? 0 : 2,
    maximumFractionDigits: marketCurrency === 'CZK' ? 0 : 2,
  });
  const singlePriceWithShipping = marketCurrency === 'CZK' ? 1495 : marketCurrency === 'PLN' ? Infinity : 59.95;
  const root = window.Shopify?.routes?.root || '/';
  let widget, submitting = false;
  const returnViews = {de:['alarmiko-camper'],fr:['alarmiko-fr','co-melder-maison','co-melder-bateau'],nl:['co-melder-camper','co-melder-huis','co-melder-boot'],cs:['detektor-co-dum'],pl:['czujnik-czadu-dom']};
  const pageUrl = new URL(window.location.href);
  const returnView = returnViews[language]?.includes(pageUrl.searchParams.get('view')) ? pageUrl.searchParams.get('view') : returnViews[language]?.[0];
  const returnPage = new URL(pageUrl.pathname, window.location.origin);
  if (returnView) returnPage.searchParams.set('view', returnView);
  const returnCountry = pageUrl.searchParams.get('country') || ({de:'DE',fr:'FR',nl:'NL',cs:'CZ',pl:'PL'})[language];
  if (returnCountry) returnPage.searchParams.set('country', returnCountry);
  const returnContext = {language, view:returnView, url:returnPage.pathname + returnPage.search};
  try { sessionStorage.setItem('alarmiko-return-v1', JSON.stringify(returnContext)); } catch (_) {}
  async function cartRequest(path, payload) {
    const response = await fetch(root + path, payload ? {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)} : {headers:{'Accept':'application/json'},cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || failures[language]);
    return data;
  }
  function readAmount(text) {
    const digits = text.replace(/[^\d.,]/g, '');
    if (!digits) return NaN;
    const decimal = /[.,](\d{2})$/.test(digits);
    return Number(digits.replace(/\D/g, '')) / (decimal ? 100 : 1);
  }
  function copyVariables(target, original) {
    for (const name of original.style) {
      if (name.startsWith('--')) target.style.setProperty(name, original.style.getPropertyValue(name));
    }
  }
  function paint(block) {
    const rows = [...block.querySelectorAll('.kaching-bundles__bar')];
    if (rows.length !== originals.length) return;
    const labels = rows.map(row => row.querySelector('label.kaching-bundles__bar-container:not([data-face])'));
    const values = labels.map(el => el ? readAmount(el.querySelector('.kaching-bundles__bar-price')?.textContent || '') : NaN);
    if (!values.every(amount => Number.isFinite(amount) && amount > 0)) return;
    const nativeRoot = rows[0].closest('.kaching-bundles__block');
    if (nativeRoot) copyVariables(nativeRoot, source);
    const barsRoot = rows[0].parentElement;
    copyVariables(barsRoot, originals[0].parentElement);
    rows.forEach((row, i) => {
      const nativeLabel = labels[i];
      const fullPrice = readAmount(nativeLabel.querySelector('.kaching-bundles__bar-full-price')?.textContent || '');
      const signature = values[i] + ':' + fullPrice + ':' + marketCurrency;
      if (row.dataset.painted === signature && row.querySelector('[data-face]')) return;
      row.querySelector('[data-face]')?.remove();
      const displayed = originals[i].querySelector('label').cloneNode(true);
      displayed.dataset.face = ''; displayed.removeAttribute('for'); displayed.setAttribute('aria-hidden', 'true');
      displayed.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      displayed.querySelectorAll('img').forEach(img => {img.loading = 'eager';});
      displayed.querySelectorAll('a[href]').forEach(el => el.removeAttribute('href'));
      displayed.querySelector('.kaching-bundles__bar-price').textContent = formatter.format(values[i]);
      if (Number.isFinite(fullPrice) && fullPrice > 0) {
        displayed.querySelector('.kaching-bundles__bar-full-price').textContent = formatter.format(fullPrice);
        const badge=displayed.querySelector('.kaching-bundles__bar-label');
        if (badge) badge.textContent=badge.textContent.replace(/\d+(?=\s*%)/, Math.round(100*(1-values[i]/fullPrice)));
      }
      if (i === 0 && values[0] !== singlePriceWithShipping) displayed.querySelector('[data-alarmiko-single-shipping]')?.remove();
      nativeLabel.setAttribute('aria-label', displayed.textContent.replace(/\s+/g,' ').trim());
      row.appendChild(displayed);
      row.dataset.offerPack = String(i + 1);
      row.dataset.painted = signature;
    });
    mount.dataset.ready = '';
  }
  function attach(block) {
    if ((mount.dataset.dealId && block.getAttribute('deal-block-id') !== mount.dataset.dealId) || !mount.contains(block) || typeof block.items !== 'function' || block === widget) return;
    widget = block;
    widget.currentVariantId = Number(mount.dataset.singleId);
    const schedule = () => requestAnimationFrame(() => paint(block));
    new MutationObserver(records => {
      if (records.some(r => !r.target.closest?.('[data-face]') && !(r.type === 'childList' && [...r.addedNodes,...r.removedNodes].every(n => n.nodeType === 1 && n.hasAttribute('data-face'))))) schedule();
    }).observe(block, {childList: true, subtree: true, characterData: true});
    block.addEventListener('items-changed', schedule);
    block.addEventListener('deal-bar-selected', schedule);
    paint(block);
  }
  document.addEventListener('kaching-bundles-block-loaded', event => attach(event.detail.component));
  const existing = mount.querySelector('kaching-bundles-block');
  if (existing) attach(existing);
  function goToCheckout() {
    if (language === 'pl') { window.location.assign('/pl/checkout?locale=pl'); return; }
    window.location.assign(form.elements.namedItem('return_to')?.value || '/checkout?locale=' + encodeURIComponent(language));
  }
  const failures={pl:'Nie udało się potwierdzić ceny zestawu. Spróbuj ponownie.',de:'Das Paket konnte nicht hinzugefügt werden. Bitte versuche es erneut.',fr:'Impossible d’ajouter le lot. Veuillez réessayer.',nl:'Het pakket kon niet worden toegevoegd. Probeer het opnieuw.',cs:'Balíček se nepodařilo přidat. Zkuste to prosím znovu.'};
  // The static cards show the control offer while the app is loading. Read its current
  // Kaching configuration so Shopify can discount an actual quantity of single devices.
  async function staticOfferLine(index, expectedPrice) {
    const selector = 'script.kaching-bundles-deal-block-settings[data-product-id="16739384721753"]';
    let blocks = document.querySelectorAll(selector);
    if (!blocks.length) {
      const url = new URL(mount.dataset.productUrl, location.origin);
      if (url.origin !== location.origin) throw new Error(failures[language]);
      url.searchParams.set('country', mount.dataset.country);
      const response = await fetch(url);
      if (!response.ok) throw new Error(failures[language]);
      blocks = new DOMParser().parseFromString(await response.text(), 'text/html').querySelectorAll(selector);
    }
    const marketId = JSON.parse(document.getElementById('kaching-bundles-config')?.textContent || '{}').marketId;
    const control = Array.from(blocks, el => JSON.parse(el.textContent)).find(deal =>
      (!mount.dataset.dealId || deal.id === mount.dataset.dealId) && deal.marketId === marketId && (deal.abTestVariantLetter === 'A' || (language === 'pl' && !deal.abTestVariantLetter)) && deal.currency?.currencyCode === marketCurrency);
    const bar = control?.dealBars.find(bar => bar.dealBarType === 'quantity-break' &&
      bar.quantity === index + 1 && bar.discountType === 'specific' && Number(bar.discountValue) === expectedPrice);
    if (!bar) throw new Error(failures[language]);
    const deal = {deal:control.nanoId, pp:16739384721753, main:true, market:marketId,
      v:control.versionId, bid:bar.id, abid:control.abTestVariantId, ab:control.abTestVariantLetter};
    return [{id:Number(mount.dataset.singleId), quantity:index+1, properties:{__kaching_bundles:JSON.stringify(deal)}}];
  }
  async function addSelected(pendingIndex) {
    if (submitting) return;
    const native = pendingIndex === undefined && widget && mount.hasAttribute('data-ready');
    if (native && !widget.validateItemSelection().valid) return;
    const cards = native ? [...widget.querySelectorAll('.kaching-bundles__bar')] : originals;
    const index = pendingIndex ?? cards.findIndex(row => row.classList.contains('kaching-bundles__bar--selected'));
    if (!cards[index]) return;
    const expectedPrice = native ? readAmount(cards[index].querySelector('[data-face] .kaching-bundles__bar-price').textContent) :
      readAmount(originals[index].querySelector('.kaching-bundles__bar-price').textContent);
    // Use the original page's handler to set the localized pack and usage properties.
    originals[index].click();
    const properties={};
    for(const [key,value] of new FormData(form)) {
      const prop=/^properties\[([^\]]+)\]$/.exec(key);
      if(prop) properties[prop[1]]=value;
    }
    const button = form.querySelector('[type=submit]');
    submitting=true; button.disabled=true; button.setAttribute('aria-busy','true');
    try {
      // Add the validated selection first; only then replace this product's old lines.
      // Other products and the native Kaching price/test properties remain intact.
      const selection = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      const lines = native ? widget.items() : await staticOfferLine(index, expectedPrice);
      if (!Number.isFinite(expectedPrice)) throw new Error(failures[language]);
      const items=lines.map(line=>({...line,properties:{...properties,...line.properties,_alarmiko_selection:selection}}));
      const expectedQuantity = items.filter(line=>Number(line.id)===Number(mount.dataset.singleId)).reduce((sum,line)=>sum+Number(line.quantity),0);
      if (expectedQuantity !== index + 1) throw new Error(failures[language]);
      await cartRequest('cart/add.js?opens_cart=never', {items});
      const current = await cartRequest('cart.js');
      const updates = {};
      current.items.forEach(line=>{
        if ((Number(line.product_id)===16739384721753 || (language==='pl' && Number(line.product_id)===16757414265177)) && line.properties?._alarmiko_selection!==selection) updates[line.key]=0;
      });
      const shipping = {};
      if (language === 'pl') {
        const code = 'DARMOWA-DOSTAWA-ALARMIKO-PL';
        const codes = (current.discount_codes || []).map(x=>x.code).filter(x=>x.toUpperCase()!==code);
        if (index > 0) codes.push(code);
        shipping.discount = codes.join(',');
      }
      const replaced = await cartRequest('cart/update.js?opens_cart=never', {updates,...shipping,attributes:{_alarmiko_locale:language,_alarmiko_view:returnView,_alarmiko_return_url:returnContext.url}});
      const selectedLines = replaced.items.filter(line=>Number(line.product_id)===16739384721753);
      if (selectedLines.reduce((sum,line)=>sum+Number(line.quantity),0)!==expectedQuantity || selectedLines.some(line=>Number(line.variant_id)!==Number(mount.dataset.singleId) || line.properties?._alarmiko_selection!==selection)) throw new Error(failures[language]);
      if (replaced.currency !== marketCurrency || selectedLines.reduce((sum,line)=>sum+line.final_line_price,0) > Math.round(expectedPrice*100)) {
        // Leave no incorrectly priced selection in the cart.
        const remove = Object.fromEntries(selectedLines.map(line=>[line.key,0]));
        await cartRequest('cart/update.js?opens_cart=never', {updates:remove});
        throw new Error(failures[language]);
      }
      goToCheckout();
    } catch(error) {
      let message=form.querySelector('[data-offer-error]');
      if (!message) {message=document.createElement('p');message.dataset.offerError='';message.setAttribute('role','alert');form.appendChild(message);}
      message.textContent = error.message || failures[language];
    } finally {
      submitting=false;button.disabled=false;button.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('submit', e=>{
    if(e.target!==form) return;
    e.preventDefault();e.stopImmediatePropagation();addSelected();
  },true);
  mount.dataset.handlerReady = '';
  if (mount.hasAttribute('data-pending-pack')) {
    const index = Number(mount.dataset.pendingPack);
    delete mount.dataset.pendingPack;
    if (Number.isInteger(index) && originals[index]) addSelected(index);
  }
})();
